import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import moment from 'moment';

import { getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_MASTER_DATA from '../../../api/apiMasterData';
import WhiteContainer from '../../../components/Container/WhiteContainer';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import IconGear from '../../../assets/icons/IconGear';
import MasterDataRolePermission from '../../../components/MasterData/MasterDataRolePermission';
import MasterDataAuditDetail from '../../../components/MasterData/MasterDataAuditDetail';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_ROLE_UPDATE } from '../../../constants/menuPermissionConstant';

class RoleEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roleId: '',
            roleDescription: '',
            rolePermission: '',
            roleLevel: {
                data: [
                    {
                        value: 'super_admin',
                        label: 'super_admin'
                    },
                    {
                        value: 'nexsoft',
                        label: 'nexsoft'
                    },
                    {
                        value: 'distributor',
                        label: 'distributor'
                    },
                    {
                        value: 'principal',
                        label: 'principal'
                    },
                    {
                        value: 'cso',
                        label: 'cso'
                    },
                ],
                selected: ''
            },
            permissionPage: false,
            roleDetail: {},
            createdAt: '',
            updatedAt: '',
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getDetailRole = () => {
        API_MASTER_DATA.getDetailRole(this.props.match.params.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        roleDetail: getContent(res),
                        createdAt: moment.utc(getContent(res).created_at).format('DD MMMM YYYY HH:mm'),
                        updatedAt: moment.utc(getContent(res).updated_at).format('DD MMMM YYYY HH:mm'),
                        roleId: getContent(res).role_id,
                        rolePermission: getContent(res).permission,
                        roleDescription: getContent(res).description,
                        roleLevel: {
                            ...this.state.roleLevel,
                            selected: getContent(res).level
                        },
                    })
                }
            }).catch(err => {
                if (err.response.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChangeRoleCategory = data => {
        this.setState({
            roleLevel: {
                ...this.state.roleLevel,
                selected: data.value
            }
        })
    }

    handleTogglePermission = () => {
        this.setState({
            permissionPage: !this.state.permissionPage
        })
    }

    handleCheckbox = data => {
        this.setState({
            rolePermission: data,
            permissionPage: !this.state.permissionPage
        })
    }

    handleSubmit = () => {
        const data = {
            role_id: this.state.roleId,
            permission: JSON.stringify(this.state.rolePermission),
            description: this.state.roleDescription,
            level: this.state.roleLevel.selected,
            updated_at: this.state.roleDetail.updated_at
        }

        API_MASTER_DATA.putDataRole(this.state.roleDetail.id, data, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                })
                setTimeout(() => {
                    this.setState({ showSuccessAlert: false })
                    this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_ROLE)
                }, 1500)
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
                if (err.response.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getDetailRole();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_ROLE_UPDATE]} userPermission={this.props.userDetail.permissions}>
                {
                    this.state.roleDetail.permission &&
                    <div className={this.state.permissionPage ? "block" : "hidden"}>
                        <MasterDataRolePermission
                            action="edit"
                            permission={this.state.roleDetail.permission}
                            handleTogglePermission={this.handleTogglePermission}
                            handleCheckbox={this.handleCheckbox}
                        />
                    </div>
                }

                <div className={this.state.permissionPage ? "hidden" : "role-container"}>
                    <div className="role-add">
                        <div className="flex justify-between">
                            <div></div>
                            <button type="button" id="btnpermission" className="rounded-full bg-white text-darkblue border-2 border-white font-bold px-5 py-2 ml-auto mb-3 flex items-center" onClick={() => this.handleTogglePermission()}>
                                <div className="bg-darkblue rounded-full flex justify-center items-center h-5 w-5 p-1">
                                    <IconGear />
                                </div>
                                <div className="ml-1">
                                    Izin Pengaturan
                                </div>
                            </button>
                        </div>
                        <WhiteContainer>
                            <div className="flex">
                                <div className="w-1/2 p-10 kiri">
                                    <div className="flex justify-between w-full mb-5">
                                        <div className="w-1/6 pr-5 text-right">
                                            <label className="select-none font-medium" htmlFor="tslroleid">Role ID</label>
                                        </div>
                                        <div className="w-5/6">
                                            <input
                                                type="text"
                                                id="tslroleid"
                                                name="roleId"
                                                className="form-control"
                                                placeholder="Tulis Role ID"
                                                defaultValue={this.state.roleDetail.role_id}
                                                onChange={this.handleChange}
                                                autoComplete="off"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-between w-full mb-5">
                                        <div className="w-1/6 pr-5 text-right">
                                            <label className="select-none font-medium" htmlFor="tmlroledescription">Deskripsi</label>
                                        </div>
                                        <div className="w-5/6">
                                            <textarea
                                                id="tmlroledescription"
                                                name="roleDescription"
                                                className="form-control resize-none h-48 2xl:h-40"
                                                placeholder="Tulis Deskripsi"
                                                defaultValue={this.state.roleDetail.description}
                                                onChange={this.handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-between w-full mb-5">
                                        <div className="w-1/6 pr-5 text-right">
                                            <label className="select-none font-medium" htmlFor="ddsrolecategory">Kategori Role</label>
                                        </div>
                                        <div className="w-5/6">
                                            {
                                                this.state.roleDetail.level &&
                                                <Select
                                                    id="ddsrolecategory"
                                                    placeholder="Pilih Kategori"
                                                    options={this.state.roleLevel.data}
                                                    defaultValue={{ label: this.state.roleDetail.level, value: this.state.roleDetail.level }}
                                                    onChange={this.handleChangeRoleCategory}
                                                    isDisabled={true}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                                <MasterDataAuditDetail
                                    createdAt={this.state.createdAt}
                                    updatedAt={this.state.updatedAt}
                                    modifiedBy={this.state.roleDetail.modified_by}
                                />
                            </div>
                            <div className="absolute bottom-5 right-5">
                                <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_ROLE)}>Batal</button>
                                <button type="button" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2" onClick={() => this.handleSubmit()}>Simpan</button>
                            </div>
                        </WhiteContainer>
                    </div>
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil Mengubah Role!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleEdit);